import type { Survey, SurveyFilters } from 'app/common/types/surveys'
import { emptySurveyFilters } from '../../filters'


export const getDefaultFilters = (survey: Survey): SurveyFilters => ({
  ...emptySurveyFilters,
  cityIds: survey.scope.cityIds || (survey.scope.cityId ? [survey.scope.cityId] : []),
  districtIds:
    survey.scope.districtIds || (survey.scope.districtId ? [survey.scope.districtId] : []),
  schoolTypes: survey.scope.schoolType ? [survey.scope.schoolType] : [],
  schoolIds: survey.scope.schoolIds || (survey.scope.schoolId ? [survey.scope.schoolId] : []),
  from: survey.startsOn,
  to: survey.endsOn,
})
